module.exports = __webpack_public_path__ + "img/grb_bled_135_135.35ba7ecd.png";